import merge from 'lodash.merge';

export default {
  setAnalyticsColumnSubTypes(state, slices) {
    state.analyticsColumnSubTypes = slices
  },
  setAnalyticsData(state, payload) {
    state.analyticsData = merge({}, state.analyticsData, payload)
  },
  setAnalyticsChart(state, payload) {
    state.analyticsChart = merge({}, state.analyticsChart, payload)
  },
  clearAnalytics(state) {
    state.analyticsData = {}
    state.analyticsChart = {}
  },
  clearFullAnalytics(state) {
    state.analyticsData = {}
    state.analyticsChart = {}
    state.analyticsPeriod = null
    state.analyticsTerritoryType = null
    state.analyticsFirstColumn = null
    state.analyticsColumnSubTypes = null
  },
  setAnalyticsTerritoryType(state, territoryType) {
    state.analyticsTerritoryType = territoryType
  },
  setAnalyticsPeriod(state, analyticsPeriod) {
    state.analyticsPeriod = analyticsPeriod
  },
  setAnalyticsFirstColumn(state, payload) {
    state.analyticsFirstColumn = payload
  },
}



// WEBPACK FOOTER //
// ./src/store/analytics/mutations.js